import { useEffect } from "react";

import Main from '../components/Home/Main'
import Common from "../components/Home/Common";
import Problems from "../components/Home/Problems";
import WhyChoose from "../components/Home/WhyChoose";
import MeatOurTeam from "../components/Home/MeatOurTeam";
import Footer from '../components/Footer'

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#FFFFFF]">
            <Main/>
            <Common/>
            <Problems/>
            <WhyChoose/>
            <MeatOurTeam/>
            <Footer />
        </div>
    );
}

export default Home;